var locationHashFilterArr = [], locationHashTabsArr = [], locationHashSortArr = [];
var hashChangeBlocked = false;
var clearInitialized = false;

const attrGroup = {
    overview: [
        'asset', 'html_name', 'primary_ticker', 'isin', 'inception_date', 'net_assets', 'currencies', 'exchanges', 'underlying_table', 'ter', 'factsheet'
    ],
    performancePeriods: [
        'asset', 'html_name', 'primary_ticker', 'isin', 'inception_date', 'nav_1m_percent', 'nav_3m_percent', 'nav_6m_percent', 'nav_1y_percent', 'nav_3y_percent', 'nav_launch_change', 'factsheet'
    ],
    performanceYears: [
        'asset', 'html_name', 'primary_ticker', 'isin', 'inception_date', 'nav_ytd_change','year_2025', 'year_2024', 'year_2023', 'year_2022', 'year_2021', 'year_2020', 'factsheet'
    ],
    riskProfile: [
        'asset', 'html_name', 'primary_ticker', 'isin', 'inception_date', 'volatility_1y', 'volatility_3y', 'volatility_5y', 'return_risk_1y', 'return_risk_3y', 'return_risk_5y', 'factsheet'
    ],
    tickers: [
        'asset', 'html_name', 'exchange-ticker', 'isin', 'exchange-product-url', 'exchange-currency', 'exchange-wkn', 'exchange-sedol', 'exchange-valoren', 'exchange-ticker-bbg', 'exchange-ric', 'factsheet'
    ],
};

// const assetOrder = ['Bitcoin', 'Bitcoin and Gold', 'Top 20 Crypto Basket', 'Ethereum', 'Staked Ethereum', 'Solana', 'Staked Solana', 'Staked Aptos', 'XRP', 'Litecoin', 'Cardano'];
// const strategyOrder = ['Bitcoin', 'Ethereum', 'Diversification', 'Core', 'Staking', 'Altcoins'];

function syncColumnWidths(table) {
    const table1 = table;
    const table2 = document.querySelector(`${table.dataset.tableheader}`);

    const columns1 = table1.querySelectorAll('th');
    const columns2 = table2.querySelectorAll('th');

    columns1.forEach((col, index) => {
        const width = col.getBoundingClientRect().width;
        columns2[index].style.minWidth = `${width}px`;
    });
}
function cvTables() {
    let cvTable = document.querySelectorAll('[data-cv-table]');

    cvTable.forEach(cvT => {
        if (cvT.dataset.cvTable === 'main-table') {
            syncColumnWidths(cvT);
            window.addEventListener('load', syncColumnWidths(cvT));
            window.addEventListener('change', syncColumnWidths(cvT));
            document.addEventListener('DOMContentLoaded', syncColumnWidths(cvT));
            window.addEventListener('resize', syncColumnWidths(cvT));
        }
    })
}

$('.crypto__card_active').hover((event) => {
    $(event.target.closest('.crypto__card')).addClass('crypto__card_show');
    setTimeout(function () {
        $(event.target.closest('.crypto__card')).removeClass('crypto__card_show');
    }, 400);
})

function createOptions(query, parent, input_opt) {
    var arrayContainer = [],
        elements = $(`[${query}]`);

    let isStrategy = query == 'data-cur-strategy';

    elements.each(function (i) {
        var testarray = this.getAttribute(query);
        // console.log(testarray);
        if (!testarray.match(/\[/g)) {
            let hasDuplicate = arrayContainer.some(item => item[0] === testarray);

            if (!hasDuplicate) {
                if (elements[i].hasAttribute(`${query}-short`)) {
                    arrayContainer.push([elements[i].getAttribute(query), elements[i].getAttribute(`${query}-short`)]);
                } else {
                    arrayContainer.push([elements[i].getAttribute(query)]);
                }
            }
        } else {
            testarray = JSON.parse(testarray);
            for (el of testarray) {
                let hasDuplicate = arrayContainer.some(item => item[0] === el);
                if (!hasDuplicate) {
                    if (!elements[i].hasAttribute(`${query}-short`)) {
                        arrayContainer.push([el]);
                    }
                }
            }
        }
    });

    if (isStrategy) {
        //console.log(arrayContainer);
    }

    arrayContainer.forEach(i => {
        let shortname = i[1] ? `<small class="bw btn btn-sm btn-gray">${i[1]}</small>` : '';
        let shortname_val = i[1] ? `data-shortname="${i[1]}"` : '';
        let uniqueId = i[0] + query;

        $(`${parent}`).append(`
                            <label class="bw-checkbox" for="ex${uniqueId}" data-display="${query}=${i[0]}" data-inputval="${i[0]}">
                                <input type="checkbox" name="${query}" id="ex${uniqueId}" value="${i[0]}" data-element="rowFilter" ${input_opt} ${shortname_val}>
                                ${i[0]}
                                ${shortname}
                            </label>
        `);
    })
}

function updateRows(blockFromChange = null) {
    var filterArray = {},
        queryGen = '',
        inputs = []
        ;

    var selectHashStrategy = [], selectHashExchange = [], selectHashCurrency = [], selectHashAsset = [];

    console.log('updateRows start');

    inputs[0] = [];
    $('#rowFilter [name="data-cur-strategy"]:checked').each(function () {
        inputs[0].push('[' + $(this).attr('name') + '*="' + $(this).val() + '"]');
        selectHashStrategy.push($(this).val());
    });

    inputs[1] = [];
    $('#rowFilter [name="data-cur-exchange"]:checked').each(function () {
        var name, val;

        if ($(this).attr('name') == 'data-cur-exchange' && $(this).val() == 'primary-listing') {
            name = 'data-primary-listing';
            val = 1;
        }
        else {
            name = $(this).attr('name');
            val = $(this).val();
        }

        inputs[1].push('[' + name + '*="' + val + '"]');
        selectHashExchange.push($(this).data('shortname'));
    });

    inputs[2] = [];
    $('#rowFilter [name="data-cur-currency"]:checked').each(function () {
        inputs[2].push('[' + $(this).attr('name') + '*="' + $(this).val() + '"]');
        selectHashCurrency.push($(this).val());
    });

    inputs[3] = [];
    $('#rowFilter [name="data-cur-asset"]:checked').each(function () {
        inputs[3].push('[' + $(this).attr('name') + '*="' + $(this).val() + '"]');
        selectHashAsset.push($(this).val());
    });

    const generateCartesianProduct = (arrays) => {
        const combineArrays = (arr1, arr2) =>
            arr1.flatMap((item1) => arr2.map((item2) => `${item1}${item2}`));

        if (arrays.length === 0) {
            return [];
        }

        let result = [...arrays[0]];

        for (let i = 1; i < arrays.length; i++) {
            result = combineArrays(result, arrays[i]);
        }

        return result.map(String);
    };

    const inputArrays = [];
    for (let i = 0; i < inputs.length; i++) {
        if (inputs[i].length) {
            inputArrays.push(inputs[i]);
        }
    }


    //console.log(inputArrays);

    //console.log('inputArrays ' + inputArrays);

    const cartesianProduct = generateCartesianProduct(inputArrays);
    queryGen = cartesianProduct.join(',');

    //console.log('queryGen' + queryGen);

    var notfound;
    notfound = 0;

    $('tr[data-cur-exchange]').each(function (i) {
        $(this).addClass('d-none');
    });

    $('tr[data-cur-exchange]').each(function (i) {
        //console.log(Object.keys($(queryGen)).length);
        if ($(this).is($(queryGen)) || !Object.keys($(queryGen)).length) {
            $(this).removeClass('d-none');
            notfound++;
        } /*else {
            $(this).addClass('d-none');
        }*/
    });



    if (!notfound) {
        $('.filter-not-found').removeClass('d-none');
    } else {
        $('.filter-not-found').addClass('d-none');
    }

    $(`[data-tdtag]`).removeClass('inactive');

    const displayOptions = [];
    $('#tickers .cryptolist tr').not('.d-none').each(function () {
        let trFields = [
            ['data-cur-strategy', $(this).data('cur-strategy')],
            ['data-cur-exchange', $(this).data('cur-exchange')],
            ['data-cur-currency', $(this).data('cur-currency')],
            ['data-cur-asset', $(this).data('cur-asset')]
        ];

        for (fieldVal of trFields) {
            if (fieldVal[1]) {
                if (typeof fieldVal[1] === 'string') {
                    if (displayOptions.indexOf(`${fieldVal[0]}=${fieldVal[1]}`) == -1) {
                        displayOptions.push(`${fieldVal[0]}=${fieldVal[1]}`);
                    }
                }
                else if (typeof fieldVal[1] === 'object') {
                    for (const [key, value] of Object.entries(fieldVal[1])) {
                        if (displayOptions.indexOf(`${fieldVal[0]}=${value}`) == -1) {
                            displayOptions.push(`${fieldVal[0]}=${value}`);
                        }
                    }
                }
            }
        }
    });


    //console.log(displayOptions);

    $('[data-display]').each(function (i) {
        if (!$(this).is($(`[name='${blockFromChange}']`).parent())) {
            $(this).addClass('d-none');
        };
    })
    $('[data-display]').each(function (i) {
        if (displayOptions.indexOf($(this).data('display')) >= 0 || $(this).find('input:checked').length) {
            $(this).removeClass('d-none');
        }
    })

    const isDnoneInBlocked = $(`[name='${blockFromChange}']`).closest('.dropdown-menu').find('.d-none').length;
    if (blockFromChange && !isDnoneInBlocked) {
        $(`[name='${blockFromChange}']`).parent().removeClass('d-none');
    }

    var selectHashStrategyStr, selectHashExchangeStr, selectHashCurrencyStr, selectHashAssetStr;
    locationHashFilterArr = [];

    selectHashStrategyStr = selectHashStrategy.join();

    selectHashStrategyStr = selectHashStrategyStr ? 'data-cur-strategy=' + selectHashStrategyStr : '';
    if (selectHashStrategyStr) {
        locationHashFilterArr.push(selectHashStrategyStr);
    }

    selectHashExchangeStr = selectHashExchange.join();
    selectHashExchangeStr = selectHashExchangeStr ? 'data-cur-exchange=' + selectHashExchangeStr : '';
    if (selectHashExchangeStr) {
        locationHashFilterArr.push(selectHashExchangeStr);
    }

    selectHashCurrencyStr = selectHashCurrency.join();
    selectHashCurrencyStr = selectHashCurrencyStr ? 'data-cur-currency=' + selectHashCurrencyStr : '';
    if (selectHashCurrencyStr) {
        locationHashFilterArr.push(selectHashCurrencyStr);
    }

    selectHashAssetStr = selectHashAsset.join();
    selectHashAssetStr = selectHashAssetStr ? 'data-cur-asset=' + selectHashAssetStr : '';
    if (selectHashAssetStr) {
        locationHashFilterArr.push(selectHashAssetStr);
    }

    var locationHash;

    setHash();
    /*
        locationHash = locationHashFilterArr.join('&');
        
        location.hash = locationHash; 
      */
    cvTables();
}

function updateSelects(priority_name, priority_val) {

    if (priority_val == 'all') {
        priority_val = window.prevPriorityVal;
        priority_name = window.prevPriorityName;
    }

    const selects = $('[data-element=rowFilter]');
    const selectsOptions = {};

    selects.each(function () {
        selectsOptions[$(this).attr('name')] = [];
    });

    $(`[${priority_name}="${priority_val}"]`).each(function () {
        const row = $(this);

        Object.keys(selectsOptions).forEach(function (key) {

            if (row.attr(key).includes(',')) {
                let splitted = row.attr(key).split(',');

                splitted.forEach(split => {
                    selectsOptions[key].push(split);
                })
            } else selectsOptions[key].push(row.attr(key));

        });
    });

    Object.keys(selectsOptions).forEach(function (key) {
        selectsOptions[key] = [...new Set(selectsOptions[key])];
    });

    $('[data-element=rowFilter]').each(function () {
        const select = $(this);
        if (select.attr('name') == priority_name) return;

        var newSelectedValue = null;

        select.find('option').each(function () {
            const option = $(this);
            const isInList = selectsOptions[select.attr('name')].includes(option.val());

            // console.log(selectsOptions[select.attr('name')], option.val());

            if (isInList || option.val() == 'all') {
                option.prop('disabled', false);
                newSelectedValue = option.val();
            } else {
                option.prop('disabled', true);
            }
        });

        if (select.find('option:selected').prop('disabled')) {
            select.val(newSelectedValue);
        }

        if (window.prevPriorityName != priority_name) {
            window.prevPriorityVal = priority_val;
            window.prevPriorityName = priority_name;
        }

        updateRows();
    });
}

function orderList(initiator, orderType, orderBy, orderDirection) {
    //console.log('ordering', initiator, orderType, orderBy, orderDirection);
    const parentTable = $($(initiator).closest('[data-synctable]').data('synctable'));

    var rows = getOrderQuery('orderVal', parentTable);

    if (orderDirection === 'default') {
        sortDefault(orderBy, rows);
    } else {
        switch (orderType) {
            case 'string':
                sortString(orderBy, rows, orderDirection);
                break;
            case 'number':
                sortNumber(orderBy, rows, orderDirection);
                break;
            case 'date-dots':
                sortDates(orderBy, rows, orderDirection);
                break;
            case 'date-raw':
                sortDatesRaw(orderBy, rows, orderDirection);
                break;
            default:
                sortDefault(orderBy, rows);
                break;
        }
    }

    rows.forEach(function (item) {
        parentTable.prepend(item[0]);
    });

    function sortDefault(orderBy, el) {
        console.log('sortdefault')
        return el.sort((a, b) => {
            return b[0].dataset.defaultOrder - a[0].dataset.defaultOrder;
        })
    }

    function sortNumber(slug, el, orderDirection) {
        let filterd = el;

        filterd.sort((a, b) => {
            const valA = Number(a[1][slug]);
            const valB = Number(b[1][slug]);

            const isNothingA = a[1][slug] === '';
            const isNothingB = b[1][slug] === '';

            if (isNothingA && !isNothingB) return 1;
            if (!isNothingA && isNothingB) return -1;

            if (!isNothingA && !isNothingB) {
                return orderDirection === 'asc' ? valB - valA : valA - valB;
            }

            return 0;
        });

        return filterd;
    }

    function parseDate(dateStr) {
        const [day, month, year] = dateStr.split('.').map(Number);
        const date = new Date(year, month - 1, day);
        return date.getTime();
    }

    function sortDatesRaw(slug, el, orderDirection) {
        el.sort((a, b) => {
            const dateRawA = new Date(a[1][slug]);
            const dateRawB = new Date(b[1][slug]);
            const dateA = dateRawA.getTime();
            const dateB = dateRawB.getTime();

            if (orderDirection === 'asc') {
                return dateB - dateA;
            } else {
                return dateA - dateB;
            }
        }
        );

        return el;
    }

    function sortDates(slug, el, orderDirection) {
        el.sort((a, b) => {
            const dateA = parseDate(a[1][slug]);
            const dateB = parseDate(b[1][slug]);

            if (orderDirection === 'desc') {
                return dateB - dateA;
            } else {
                return dateA - dateB;
            }
        }
        );

        return el;
    }

    function sortString(slug, el, orderDirection) {
        if (orderDirection === 'desc') {
            el.sort((a, b) => b[1][slug].localeCompare(a[1][slug]));
        } else {
            el.sort((a, b) => a[1][slug].localeCompare(b[1][slug]));
        }
        return el;
    }
}


$(document).on('click', '[data-enabled-order] [data-order]', function (e) {
    console.log('Element clicked:', this);
    e.stopPropagation();

    let ordering = $(this).attr('data-order-dir');
    let isString = $(this).data('orderType') === 'string';

    //console.log(isString);

    // switch (orderType) {
    //     case 'string':
    //         sortString(orderBy, rows, orderDirection);
    //         break;
    //     case 'number':
    //         sortNumber(orderBy, rows, orderDirection);
    //         break;
    //     case 'date-dots':
    //         sortDates(orderBy, rows, orderDirection);
    //         break;
    //     case 'date-raw':
    //         sortDatesRaw(orderBy, rows, orderDirection);
    //         break;
    //     default:
    //         sortDefault(orderBy, rows);
    //         break;
    // }

    if (isString) {
        switch (ordering) {
            case 'default':
                ordering = 'asc';
                break;
            case 'asc':
                ordering = 'desc';
                break;
            case 'desc':
                ordering = 'default';
                break;
            default:
                break;
        }
    } else {
        switch (ordering) {
            case 'default':
                ordering = 'desc';
                break;
            case 'desc':
                ordering = 'asc';
                break;
            case 'asc':
                ordering = 'default';
                break;
            default:
                break;
        }
    }

    $('[data-enabled-order] [data-order]').attr('data-order-dir', 'default');
    $(this).attr('data-order-dir', ordering);

    orderList($(this), $(this).data('orderType'), $(this).data('order'), ordering);

    locationHashSortArr = [];
    locationHashSortArr.push('data-order=' + $(this).data('order') +
        '&data-order-dir=' + ordering + '&data-order-type=' + $(this).data('orderType'));
    setHash();
});

function reorderSelectItems(select, orderList) {
    const newOrderedItems = orderList.map(el => $(`${select} [data-inputval="${el}"]`));

    $(select).empty().append(newOrderedItems);
}

function setActiveGroup(group) {
    let tableRow = $('[data-cv-table] tr');

    tableRow.each(function () {
        const row = $(this);

        if (row.find('th').length) reorderColumns(row.find('th'));
        if (row.find('td').length) reorderColumns(row.find('td'));

        function reorderColumns(cells) {
            const allCols = {};
            const orderedCols = [];

            cells.each(function () {
                allCols[$(this).data('attrSlug')] = $(this)[0];
            })

            $.each(group, function (index, value) {
                orderedCols.push(allCols[value]);
                delete allCols[value];
            })

            row.empty();

            $.each(orderedCols, function (index, value) {
                row.append(value);
            })
            $.each(allCols, function (index, value) {
                row.append(value);
            })
        }
    })

    let tableCell = document.querySelectorAll('.cryptolist [data-attr-slug]');

    tableCell.forEach(el => {
        el.classList.toggle('d-none', !group.includes(el.dataset.attrSlug))
    })

    cvTables();

    setTimeout(() => renderScrollBar($('.tab-pane.d-block [data-myscrollbar]')), 100);

    $(window).resize(() => {
        renderScrollBar($('.tab-pane.d-block [data-myscrollbar]'));
    })
}

function getOrderQuery(dataQuery, parentTable) {
    var current_selection = [];

    // console.log(parentTable);

    $(parentTable).find(`[data-table-row]:not(.d-none)`).each(function () {
        const el = $(this)[0];
        const orderValues = {};
        $(el).find('td').each(function () {
            orderValues[$(this).data('attrSlug')] = $(this).data(dataQuery);
        })

        current_selection.push([el, orderValues]);
    });

    return current_selection;
}

/*
$('[data-element=rowFilter]').change(function () {
    updateRows();
    updateSelects($(this).attr('name'), $(this).val());
})
*/
$('body').on('change', '[name="data-cur-exchange"], [name="data-cur-strategy"], [name="data-cur-currency"], [name="data-cur-asset"]', function (e) {
    updateRows($(this).attr('name'));
    updateCheckboxes();
})


function updateCheckboxes() {
    $('.exchange-reset-filter').hide();

    $('#rowFilter .dropdown.bw-dropdown').each(function () {
        //
        var $dropdown = $(this);

        var selected_counter = 0;
        var selected_values = [];

        $dropdown.find('.selected_checkboxes').remove();
        $dropdown.find('.bw-select-clear').remove();
        $dropdown.find('button.bw-select').removeClass('bw-select-active');

        $(this).find('input[type=checkbox]:checked').each(function () {
            //console.log('test ' + $(this).val(), $(this));
            selected_counter++;
            selected_values.push($(this).attr('data-shortname') ? $(this).attr('data-shortname') : $(this).val());
        })

        if (selected_counter) {
            var inserted_checkboxes = '';

            if (selected_counter > 1) {
                inserted_checkboxes += `
                    <span class="selected_checkboxes">
                    ${selected_counter}
                    </span>
                    `;
            } else {
                for (let i = 0; i < selected_values.length; i++) {
                    inserted_checkboxes += `
                    <span class="selected_checkboxes" data-a="${selected_values}">${selected_values[i]}
                    </span>
                    `;
                }
            }

            $dropdown.find('button.bw-select').addClass('bw-select-active');

            $dropdown.find('button.bw-select').append(inserted_checkboxes);

            $dropdown.find('button.bw-select').after(`<button class="bw-select-clear" data-clear="#testName" title="Clear">
                        Clear
                    </button>`);
            $('.exchange-reset-filter').show();
        }
    })
}

$(document).ready(function () {
    cvTables();

    createOptions('data-cur-exchange', '#exchangeName', '');
    createOptions('data-cur-currency', '#curName', '');
    createOptions('data-cur-asset', '#assetName', '');
    createOptions('data-cur-strategy', '#stratName', '');

    // reorderSelectItems('#assetName', assetOrder);
    // reorderSelectItems('#stratName', strategyOrder);
    parseHash();

    if ($.cookie("bw_country") === 'gb' && $.cookie("bw_investor_type") === '0') {
        setCustomTweaks({
            preselectExchanges: ['LSE', 'AQXE'],
        })
    }
}
)

function initClear() {
    if (clearInitialized) return;
    clearInitialized = true;
    $('body').on('click', '.bw-select-clear', function () {
        $(this).parents('.dropdown.bw-dropdown').find('input[type="checkbox"]:checked').each(function () {
            $(this).prop('checked', false);
        });

        updateRows();
        updateCheckboxes();
    });

    $('.exchange-reset-filter').click(function () {
        $('#rowFilter').find('input[type="checkbox"]:checked').each(function () {
            $(this).prop('checked', false);
        });

        updateRows();
        updateCheckboxes();
    });
}

function drawTrUnderline() {
    const tableParentWidth = $('.tab-pane.d-block [data-cv-table=main-table]').parent().width();
    const tableBodyWidth = $('.tab-pane.d-block [data-cv-table=main-table]').width();

    let borderWidth = tableParentWidth > tableBodyWidth ? tableParentWidth : tableBodyWidth;

    $('.tab-pane.d-block [data-cv-table=main-table]').parent().attr('style', `--parent-table-tab-width: ${borderWidth}px`);
}

$(document).on('click', '.cryptolist__title-button', function (e) {
    const trigger = $(this).hasClass('active');

    $(this).toggleClass('active', !trigger);
    $(this).closest('.cryptolist__tr').toggleClass('opened', !trigger);

})

$(document).on('click', '[data-attr-group]', function () {
    $('[data-attr-group]').removeClass('active');
    $(this).addClass('active');
    let group = $(this).attr('data-attr-group');
    $('[data-toggle="popover"]').popover()
    setActiveGroup(attrGroup[group]);

    drawTrUnderline();

    locationHashTabsArr = [];
    locationHashTabsArr.push('data-attr-group=' + group);
    setHash();
})

$(document).on('mouseenter', '[data-toggle="popover"][data-trigger="hover"]', function () {
    $(this).popover('show');
});

$(document).on('mouseleave', '[data-toggle="popover"][data-trigger="hover"]', function () {
    $(this).popover('hide');
});

$(document).on('click', '.dropdown-menu label', function (event) {
    event.stopPropagation();
});

function setHash() {
    var resultHash = [];

    resultHash = locationHashFilterArr.concat(locationHashTabsArr, locationHashSortArr);
    locationHash = resultHash.join('&');

    location.hash = locationHash;
}

function parseHash() {
    let searchParams = window.location.hash.replace('#', '').split('&');
    let queryParams = {};

    for (let param of searchParams) {
        let [key, value] = param.split('=');
        queryParams[key] = decodeURIComponent(value || "");
    }

    if (window.location.hash) {

        drawValueDirection();
        drawTrUnderline();

        // tabs
        if (queryParams['data-attr-group']) {
            $('[data-attr-group=' + queryParams['data-attr-group'] + ']').trigger('click');
        }

        // filter
        if (queryParams['data-cur-asset']) {
            let asset = queryParams['data-cur-asset'].split(',');
            for (let s of asset) {
                $('[name=data-cur-asset][value="' + s + '"]').trigger('click');
            }
        }

        if (queryParams['data-cur-strategy']) {
            let strategy = queryParams['data-cur-strategy'].split(',');
            for (let s of strategy) {
                $('[name=data-cur-strategy][value="' + s + '"]').trigger('click');
            }
        }
        if (queryParams['data-cur-exchange']) {
            let exchange = queryParams['data-cur-exchange'].split(',');
            for (let s of exchange) {
                $('[name=data-cur-exchange][data-shortname="' + s + '"]').trigger('click');
            }
        }

        if (queryParams['data-cur-currency']) {
            let currency = queryParams['data-cur-currency'].split(',');
            for (let s of currency) {
                $('[name=data-cur-currency][value="' + s + '"]').trigger('click');
            }
        }

        // sort
        if (queryParams['data-order']) {
            let order = queryParams['data-order'];

            let order_dir = queryParams['data-order-dir'];

            let order_type = queryParams['data-order-type'];


            let isString = order_type === 'string';

            if (isString) {
                switch (order_dir) {
                    case 'default':
                        order_dir = 'desc';
                        break;
                    case 'asc':
                        order_dir = 'default';
                        break;
                    case 'desc':
                        order_dir = 'asc';
                        break;
                    default:
                        break;
                }
            } else {
                switch (order_dir) {
                    case 'default':
                        order_dir = 'asc';
                        break;
                    case 'desc':
                        order_dir = 'default';
                        break;
                    case 'asc':
                        order_dir = 'desc';
                        break;
                    default:
                        break;
                }
            }

            if (order_dir) {
                $('[data-order="' + order + '"]').attr('data-order-dir', order_dir);
            }
            if (order_type) {
                $('[data-order="' + order + '"]').attr('data-order-type', order_type);
            }

            $('[data-order="' + order + '"]:visible').trigger('click');
        }
        initClear();
        updateRows();
    }
    else {
        updateRows();
        drawValueDirection();
        drawTrUnderline();

        $('[data-attr-group=overview]').trigger('click');
        initClear();
    }
}

document.querySelectorAll('[data-exchange-toggle]').forEach(toggler => {
    toggler.addEventListener('click', () => {
        const defaultClasses = 'btn btn-xs ';
        const isBW = toggler.classList.contains('bw');
        const states = {
            default: ['active btn-outlined', 'btn-outlined text-black'],
            bitwise: ['bw btn-dark', 'bw btn-outlined btn-grey']
        };
        toggler.closest('[data-exchange-togglers]').querySelectorAll('[data-exchange-toggle]').forEach(togglers => {
            const isBW = togglers.classList.contains('bw');
            togglers.classList.remove();
            togglers.setAttribute('class', defaultClasses + states[isBW ? 'bitwise' : 'default'][1]);
        })
        toggler.setAttribute('class', defaultClasses + states[isBW ? 'bitwise' : 'default'][0]);

        let exchanges = document.querySelectorAll('[data-exchange-currency]');

        exchanges.forEach(exc => {
            exc.classList.toggle('d-none', exc.dataset.exchangeCurrency != toggler.dataset.exchangeToggle);
        })
    })
});



$(window).on('hashchange', function () {
    if (hashChangeBlocked) return;
    hashChangeBlocked = true;

    $('#rowFilter input[type="checkbox"]:checked').prop('checked', false);
    locationHashFilterArr = [];
    locationHashTabsArr = [];
    locationHashSortArr = [];

    parseHash();

    setTimeout(function () {
        hashChangeBlocked = false;
    }, 150);
});

function setCustomTweaks(options) {
    if (options.preselectExchanges) {
        $(options.preselectExchanges).each(function () {
            $(`[data-shortname="${this}"]`).closest('label').click();
        })
    }
}